import * as React from "react";

export const YinYangSvg = ({}) => (
    <svg viewBox="0 0 298.962 298.962" >
        <path d="M211.157,13.354C191.596,4.493,170.875,0,149.567,0C90.989,0,37.522,34.466,13.354,87.806
					c-34.006,75.061-0.607,163.792,74.453,197.801c19.559,8.86,40.281,13.354,61.59,13.354c58.577,0,112.043-34.467,136.211-87.809
					C319.614,136.094,286.215,47.36,211.157,13.354z M135.135,55.576c12.703,0,23.001,10.297,23.001,23
					c0,12.702-10.298,23-23.001,23c-12.701,0-22.998-10.298-22.998-23C112.138,65.873,122.435,55.576,135.135,55.576z
					 M206.631,244.693c-8.192,25.221-38.349,47.979-85.198,38.352v0.003c-9.65-2.036-19.096-5.131-28.26-9.282
					C24.642,242.716-5.852,161.703,25.196,93.17C39.6,61.381,65.407,36.953,96.466,23.814c1.777-0.751,4.301-0.423,1.301,1.952
					C84.9,35.596,80.318,44.513,77.208,58.893c-6.186,28.607,8.848,68.982,69.59,96.502
					C203.958,181.293,214.752,219.686,206.631,244.693z"
              fill="currentColor"
        />
        <g>
            <circle cx="163.409" cy="228.418" r="23" stroke="none" fill="currentColor"/>
        </g>
    </svg>

);
